var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "info", attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("common.info")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("session-switch")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "danger",
              on: {
                click: function ($event) {
                  return _vm.signout()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("signout")) + " ")]
          ),
          _c(
            "w-button",
            {
              staticClass: "ml",
              on: {
                click: function ($event) {
                  return _vm.switchSession()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.yes")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }